import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getRoles } from "../../api/apiRoles";

export const useGetRoles = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["roles", params, i18next.language],
        queryFn: () => getRoles(params),
        keepPreviousData: true,
    });

    const root = data?.data;
    let roles = [];
    let meta = data?.meta;
    if (Array.isArray(root)) {
        roles = root;
    } else if (root && Array.isArray(root.data)) {
        roles = root.data;
        meta = meta || root.meta;
    }

    return {
        isLoading,
        error,
        roles,
        meta: meta || { current_page: 1, per_page: params?.per_page || 15, total: roles.length },
        refetch,
    };
};
